var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChallenges({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M486.4 25.6h-76.8V0H102.4v25.6H25.6C10.24 25.6 0 35.84 0 51.2v61.44c0 58.88 43.52 107.52 102.4 115.2v2.56c0 74.24 51.2 135.68 120.32 151.04L204.8 435.2h-58.88c-10.24 0-20.48 7.68-23.04 17.92L102.4 512h307.2l-20.48-58.88c-2.56-10.24-12.8-17.92-23.04-17.92H307.2l-17.92-53.76c69.12-15.36 120.32-76.8 120.32-151.04v-2.56c58.88-7.68 102.4-56.32 102.4-115.2V51.2c0-15.36-10.24-25.6-25.6-25.6zm-384 151.04c-28.16-7.68-51.2-33.28-51.2-64V76.8h51.2v99.84zM307.2 256L256 227.84 204.8 256l12.8-51.2-38.4-51.2h53.76L256 102.4l23.04 51.2h53.76l-38.4 51.2 12.8 51.2zm153.6-143.36c0 30.72-23.04 58.88-51.2 64V76.8h51.2v35.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChallenges);
export default __webpack_public_path__ + "static/media/icon_challenges.9ec587edc1f643a53f550fd069efe19c.svg";
export { ForwardRef as ReactComponent };